import { Module } from "vuex";

export const SmsCompany: Module<any, any> = {
  state: {
    querySearchSmsCompany: {},
    currentPageSmsCompany: {},
  },
  getters: {
    querySearchSmsCompany: (state) => state.query,
    currentPageSmsCompany: (state) => state.query,
  },
  mutations: {
    setquerySearchSmsCompany(state, data) {
      state.querySearchSmsCompany = data;
    },
    setcurrentPageSmsCompany(state, data) {
      state.currentPageSmsCompany = data;
    },
  },
  actions: {
    setcurrentPageSmsCompany(data) {
      console.log(data);
      data.commit("setcurrentPageSmsCompany");
    },
    setquerySearchSmsCompany(query) {
      query.commit("setquerySearchSmsCompany");
    },
  },
};
